import { useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";
import { uploadOne } from "./useS3Upload";

export const useMessages = () => {
  const queryClient = useQueryClient();

  const sendMessageMutation = useMutation(
    async ({ conversationId, message, file, audioURL, channel, projectId, userId, phone, email, emailTo, emailSubject, emailCc, templateId }) => {
      if (!conversationId) throw new Error("ID da conversa não informado.");

      const messagePayload = {
        conversationId,
        type: file ? "file" : audioURL ? "audio" : "text",
        content: message?.trim() || "",
        channel,
        projectId,
        userId,
        phone,
        email: emailTo ?? email,
        ...(emailTo != null && { emailTo }),
        ...(emailSubject != null && { emailSubject }),
        ...(emailCc != null && { emailCc }),
        ...(templateId != null && { templateId }),
      };

      // console.log("✅ sendMessageMutation Payload (Antes de conversão):", messagePayload);

      // 🔹 Upload do arquivo para S3, se houver, retornando URL pública
      if (file) {
        const uploaded = await uploadOne(file, { prefix: "chat" });
        messagePayload.file = {
          url: uploaded.url,
          key: uploaded.key,
          name: file.name,
          type: file.type,
          size: file.size,
        };
      }

      // 🔹 Faz upload do áudio gravado para o S3 (mic-recorder-to-mp3 gera MP3)
      // Gupshup exige audio/mpeg (não audio/mp3) para áudio
      if (audioURL) {
        const audioBlob = await fetchBlobFromUrl(audioURL);
        const mimeType = audioBlob.type && audioBlob.type !== "audio/mp3" ? audioBlob.type : "audio/mpeg";
        const fileName = `audio-${Date.now()}.mp3`;
        const audioFile = new File([audioBlob], fileName, { type: mimeType });
        const uploaded = await uploadOne(audioFile, { prefix: "chat" });
        messagePayload.audio = uploaded.url;
      }

      // console.log("✅ Payload Final com Base64:", messagePayload);

      return fetchData("/messages", "POST", messagePayload);
    },
    {
      onSuccess: (_, { conversationId }) => {
        queryClient.invalidateQueries(["conversationDetails", conversationId]);
      },
      onError: (error) => {
        console.error("❌ Erro ao enviar mensagem:", error);
      },
    }
  );

  return { sendMessageMutation };
};

/**
 * 🔹 Obtém um Blob a partir de uma URL (usado para enviar o áudio gravado)
 */
const fetchBlobFromUrl = async (url) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error("Falha ao preparar arquivo de áudio para envio.");
  }
  return await response.blob();
};
